import * as $ from "jquery";
import imkt from '../../../imkt';

imkt.legal.Main = class LegalMain {
  $domRoot: HTMLElement;
  params: {};
  mobileNavHeader: JQuery<HTMLElement>;
  mobileNavContent: JQuery<HTMLElement>;
  activeLinkInAside: JQuery<HTMLElement>;
  targetArray: NodeListOf<Element>;
  data: any[];

  constructor(domRoot: HTMLElement, params: {}) {
    this.$domRoot = domRoot || $("body");
    this.params = { ...params };

    this.mobileNavHeader = $(".subnavigation--mobile--header");
    this.mobileNavContent = $(".subnavigation--mobile--content");
    this.activeLinkInAside = $("main .block__view__list .cms-link.active");
    this.targetArray = document.querySelectorAll("main h2");
    this.data = this.subNavData();

    this.init();
  }

  init() {
    this.bindEvents();

    if (this.activeLinkInAside.length && this.data.length) {
      this.activeLinkInAside.after("<ul>" + this.buildSubNav() + "</ul>");
    }
  }

  bindEvents() {
    this.mobileNavHeader.on("click", () => {
      this.toggleSubnavigation();
    });
  }

  toggleSubnavigation() {
    this.mobileNavHeader.toggleClass("closed");
    this.mobileNavContent.toggleClass("closed");
  }

  subNavData() {
    let dataSet: object[] = [];
    this.targetArray.forEach((el) => {
      let elId = el.id;
      if (el.parentNode.className.indexOf("component--heading") > -1) {
        elId = el.parentNode.id;
      }
      if (elId !== "" && el.textContent !== "") {
        dataSet.push({
          id: elId,
          content: el.textContent,
        });
      }
    });
    return dataSet;
  }

  buildSubNav() {
    let subNav = this.data.reduce((acc, el) => {
      if (el.id === "") {
        return acc;
      }
      return (acc += `<li class="aside-subnav-items"><a href="#${el.id}">${el.content}</a></li>`);
    }, "");
    return subNav;
  }
}

new imkt.legal.Main();
